function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1896",
  "data-name": "Group 1896",
  transform: "translate(-571 -323)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_9",
  "data-name": "Ellipse 9",
  cx: 16,
  cy: 16,
  r: 16,
  transform: "translate(571 323)",
  fill: "#eeeff3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_282",
  "data-name": "Path 282",
  d: "M7.84,14.3V10.8h2.8v3.5a.7.7,0,0,0,.7.7h2.1a.7.7,0,0,0,.7-.7V9.4h1.19a.347.347,0,0,0,.231-.609L9.709,3.523a.705.705,0,0,0-.938,0L2.92,8.794a.349.349,0,0,0,.231.609H4.34v4.9a.7.7,0,0,0,.7.7h2.1A.7.7,0,0,0,7.84,14.3Z",
  transform: "translate(577.758 329.826)",
  fill: "#00cd98"
}));

var SvgHousingType = function SvgHousingType(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHousingType, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/housing-type.316b38b7.svg";
export { ForwardRef as ReactComponent };